import { render, staticRenderFns } from "./LayoutsList.vue?vue&type=template&id=643f4052"
import script from "./LayoutsList.vue?vue&type=script&lang=js"
export * from "./LayoutsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports